<template>
  <div>
    <div class="head_top">
      <div class="header-main">
        <div class="logo">
          <div class="logo_img">
            <img src="https://resource.rcclchina.com.cn/logo/PC/logoHeaderBlue.png"
              onclick="javascript:window.open('/')" />
          </div>
        </div>
        <!-- 步骤条 -->
        <div class="step-warp">
          <!-- 步骤一 -->
          <!-- <div class="step-prev-line"><div></div></div> -->
          <div class="step-finish"></div>
          <!-- <div class="step step1">1</div> -->
          <div class="step-next-line">
            <div></div>
          </div>
          <div class="step-text">选择游轮舱房</div>

          <!-- 步骤二 -->
          <div class="step-prev-line">
            <div></div>
          </div>
          <!-- <div class="step-finish finish1"></div> -->
          <div class="step step1">2</div>
          <div class="step-next-line">
            <div></div>
          </div>
          <div class="step-text" style="left: 104px">填写乘客信息</div>

          <!-- 步骤三 -->
          <div class="step-prev-line">
            <div class="gray"></div>
          </div>
          <!-- <div class="step-finish finish1"></div> -->
          <div class="step gray">3</div>
          <div class="step-text" style="width: 70px; left: 256px">确认支付</div>
        </div>
      </div>
    </div>
    <div class="content-warp" v-if="isInitComplete">
      <div class="content">
        <div class="content-tips">
          <div class="bg"></div>
          <!--开航日45天前既可以使用订金预订又可以进行快速预订-->
          <template v-if="order.isDownPayCruise">
            <div class="inner">
              <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
              <div class="row-1">恭喜您！获得<em>订金预订特权</em></div>
              <div class="row-2">请于<span id="countDown">{{ countDownText }}</span>内完成以下信息填写。</div>
            </div>
          </template>
          <!--开航日45天-14天前仅可使用快速预订，不可进行订金预订-->
          <template v-else-if="!order.isDownPayCruise && order.isAllowQuickOrder">
            <div class="inner">
              <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
              <div class="row-1">恭喜您！获得<em>快速预订特权</em></div>
              <div class="row-2">仅需填写<em>1位</em>乘客即可锁定心仪房型。请于<span id="countDown">{{ countDownText }}</span>内完成以下信息填写。
              </div>
            </div>
          </template>
          <!--开航日前14天以内无法使用任何订金以及快速预订-->
          <template v-else>
            <div class="inner-center">
              <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`" />
              <div class="row">恭喜您！<em>锁定心仪舱房</em>请于<span id="countDown">{{ countDownText }}</span>内完成以下信息填写。</div>
            </div>
          </template>
        </div>
        <div class="content-main">
          <div class="content-main-left">
            <div class="form-warp">
              <div class="contact-warp">
                <div class="contact-title">联系人信息</div>
                <div class="contact-save-btn">
                  <RcclCheckBox :title="'保存为常用联系人'" :defaultChecked="bookingContact.isCommonUseContact"
                    v-on:onChanged="checkIsCommonChanged" />
                  <span class="claer-lable" id="contact-clear" @click="clearBookingContact">清空</span>
                </div>
                <div class="contact-form">
                  <div class="input-warp">
                    <label for="contactor" class="input-lable" :class="{ 'sms': isShowSmsCode }">中文姓 </label>
                    <input type="text" class="guestLastName" id="contactor" placeholder="请输入中文姓"
                      v-model="bookingContact.chineseLastName" @focus="onSelectContactShow(1)"
                      @change="onNameChanged('lastName')" />
                    <SelectContact v-if="isShowSelectContact === 1" :style="selectContactPosition"
                      :onClose="onSelectContactClose" :limit="1" :bookingLimit="4"
                      :onContactConfirm="onSelectContactConfirm" :isContact="true" />
                  </div>
                  <div class="input-warp">
                    <label for="contactor" class="input-lable" :class="{ 'sms': isShowSmsCode }">中文名 </label>
                    <input type="text" class="guestLastName" id="contactor" placeholder="请输入中文名"
                      v-model="bookingContact.chineseFirstName" @focus="onSelectContactShow(2)"
                      @change="onNameChanged('firstName')" />
                    <SelectContact v-if="isShowSelectContact === 2" :style="selectContactPosition"
                      :onClose="onSelectContactClose" :limit="1" :bookingLimit="4"
                      :onContactConfirm="onSelectContactConfirm" :isContact="true" />
                  </div>
                  <div class="input-warp">
                    <label for="contactor" class="input-lable" :class="{ 'sms': isShowSmsCode }">拼音姓 </label>
                    <input type="text" class="guestLastName" id="contactor" placeholder="请输入拼音姓"
                      v-model="bookingContact.pinyinLastName" @focus="onSelectContactShow(3)" />
                    <SelectContact v-if="isShowSelectContact === 3" :style="selectContactPosition"
                      :onClose="onSelectContactClose" :limit="1" :bookingLimit="4"
                      :onContactConfirm="onSelectContactConfirm" :isContact="true" />
                  </div>
                  <div class="input-warp">
                    <label for="contactor" class="input-lable" :class="{ 'sms': isShowSmsCode }">拼音名 </label>
                    <input type="text" class="guestLastName" id="contactor" placeholder="请输入拼音名"
                      v-model="bookingContact.pinyinFirstName" @focus="onSelectContactShow(4)" />
                    <SelectContact v-if="isShowSelectContact === 4" :style="selectContactPosition"
                      :onClose="onSelectContactClose" :limit="1" :bookingLimit="4"
                      :onContactConfirm="onSelectContactConfirm" :isContact="true" @focus="onSelectContactShow(4)" />
                  </div>
                  <div class="input-warp">
                    <label for="phone" class="input-lable" :class="{ 'sms': isShowSmsCode }">手机号 </label>
                    <div class="dropdown callingCode" id="contactCallingCode">
                      <!--                      <button-->
                      <!--                          class="btn btn-default dropdown-toggle"-->
                      <!--                          type="button"-->
                      <!--                          id="callingCodeDropDown"-->
                      <!--                          data-toggle="dropdown"-->
                      <!--                          aria-haspopup="true"-->
                      <!--                          aria-expanded="false"-->
                      <!--                      >-->
                      <!--                        <span class="callingcode-name">{{-->
                      <!--                            `${selectedCallingCode.countryName}(${selectedCallingCode.callingCode})`-->
                      <!--                          }}</span>-->
                      <!--                        <span class="caret"></span>-->
                      <!--                      </button>-->
                      <!--                      <ul-->
                      <!--                          class="dropdown-menu"-->
                      <!--                          aria-labelledby="callingCodeDropDown"-->
                      <!--                      >-->
                      <!--                        <li-->
                      <!--                            v-for="(code, i) in callingCodes"-->
                      <!--                            :key="'callingCode_' + i"-->
                      <!--                        >-->
                      <!--                          <a @click="callingCodeChanged(code.callingCode)">{{-->
                      <!--                              `${code.countryName}(${code.callingCode})`-->
                      <!--                            }}</a>-->
                      <!--                        </li>-->
                      <!--                      </ul>-->
                    </div>
                    <input type="text" placeholder="请输入手机号" id="phone" name="Telephone"
                      v-model="bookingContact.telephone" />
                  </div>
                  <div v-show="isShowSmsCode" class="input-warp contacts-row-codeImg">
                    <label for="imgCode" class="input-lable" :class="{ 'sms': isShowSmsCode }">图形验证码</label>
                    <input type="text" id="indentifyingCode" v-model="picCode" class="imgCode" maxlength="4"
                      placeholder="请输入图形验证码" />
                    <img id="code" class="i1_pic picCodeImg" title="" :src="picCodeImage" style="cursor: pointer" />
                  </div>
                  <div v-show="isShowSmsCode" class="input-warp">
                    <label for="smsCode" class="input-lable" :class="{ 'sms': isShowSmsCode }">短信验证码</label>
                    <input type="text" maxlength="6" class="sms__code" v-model="smsCode" name="contactTelephone"
                      placeholder="请输入验证码" />
                    <span class="get--sms font--blue contacts-row-sms" @click="sendSmsCode()"
                      style="white-space: nowrap;margin-left: 20px">{{ smsCodeText }}</span>
                  </div>
                  <div class="input-warp">
                    <label for="email" class="input-lable" :class="{ 'sms': isShowSmsCode }">电子邮箱</label>
                    <input type="text" placeholder="请输入邮箱" id="email" v-model="bookingContact.email" />
                    <!--                    <span class="comment-css"-->
                    <!--                    >请认真输入电子邮箱，我们将会给您发送订单相关信息及注意事项。</span-->
                    <!--                    >-->
                  </div>
                </div>
              </div>
            </div>
            <div class="tips-warp comment-css">
              <div>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" alt="" />
                <span class="comment-css">我们高度重视您的个人信息的保护。请查阅<a href="/Rccl.UserCenter/Privacy"
                    target="_blank">隐私政策</a>以了解我们的个人信息处理规则。</span>
              </div>
              <div>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" alt="" />
                <span class="comment-css">提示：每间舱房需有1名21周岁及以上成人，所有客人必须持有在航次结束后仍有6个月以上有效期的护照</span>
              </div>
              <div v-if="!isLocalReward">
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" alt="" />
                <span class="comment-css">提示：加入<a @click="goToLocalReward">皇家游享荟</a>并完善信息，方可获得丰厚船票预订积分和会员专属福利。
                </span>
              </div>
              <div v-else-if="!isFinishSelfInfo">
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" alt="" />
                <span class="comment-css">提示：皇家游享荟会员本人需
                  <a @click="goToCompleteInfo"> 完善信息 </a>
                  并准确录入乘客本人护照号，方可获得会员积分，每间舱房仅有1人可获得积分。</span>
              </div>
              <div>
                <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png" alt="" />
                <span class="comment-css">提示：同一航次，同一乘客不可重复添加</span>
              </div>

            </div>

            <!-- 连通房 -->
            <GuestInfoStateroom v-for="(connectBooking, i) in connectBookings" :key="'connectBooking_' + i"
              :booking="connectBooking" :coupons="coupons" :isFirstConnectRoom="i == 0" :index="i" :isConnectRoom="true"
              :bookingsOriginal="bookingsOriginal" :onCouponCodeSelected="onCouponCodeSelected"
              :addPublicCouponCode="addPublicCouponCode" :userDetail="userDetail" 
              :showRow="order.bookingIndex.isRow"
              :showDeckImg="order.showDeckImg"
              />

            <!-- 普通房型 -->
            <GuestInfoStateroom v-for="(booking, i) in normalBookings" :key="'normalBooking_' + i" :booking="booking"
              :coupons="coupons" :index="i + connectBookings.length" :isConnectRoom="false"
              :bookingsOriginal="bookingsOriginal" :onCouponCodeSelected="onCouponCodeSelected"
              :addPublicCouponCode="addPublicCouponCode" :userDetail="userDetail" 
              :showRow="order.bookingIndex.isRow"
              :showDeckImg="order.showDeckImg"
              />
              
              <template v-if="order.bookingIndex"
              
              >
                <!-- 岸上观光 -->
                <GuestInfoShorex v-if="order.bookingIndex.isRow == false"/>
                <!-- ROW调整-等待设计稿 | 等待文案 -->
                <!-- 关于海外航线“预付费类”船上产品或服务的重要说明： -->
                <GuestInfoShorexRow v-else/>
             </template>
            <!-- 预订政策 -->
            <div class="product-info detailpage">
              <div class="product-title">预订政策：</div>
              <div class="css_Reservation">
                <CruiseDetailPolicy :customClass="'guestInfo'" :visaContent="order.visaWarning"
                  :departureCode="order.departureCode" :isFortyEightHoursNrpCruise="order.isFortyEightHoursNrpCruise"
                  :isSevenDayNrpCruise="order.isSevenDayNrpCruise" :hasNrp="hasNrp" :hasRp="hasRp"
                  :portAddress="order.portAddress" :specialBookingInfo="specialBookingInfo" :shipCode="shipCode"
                  :sailDate="sailDate" :isDownPayCruise="order.isDownPayCruise"
                  :showRow="order.bookingIndex.isRow" />
              </div>
            </div>
          </div>
          <!-- 右半边内容 -->
          <GuestInfoRight :isDownPayCruise="order.isDownPayCruise" :submitBooking="checkGuestRepeatSubmitBooking"
            :goBack="goBackShoppingCart" :isFinishSelfInfo="isFinishSelfInfo" />
          <!--          <div v-if="!isShowPromptPopups" class="promptPopups">-->
          <!--            <div class="promptPopups-main">-->
          <!--              <div class="promptPopups-main-title"></div>-->
          <!--              <div class="countdown">{{promptPopupsCountdown}}秒</div>-->
          <!--              <div class="promptPopups-main-text">-->
          <!--                <div class="promptPopups-con-title">您即将进入信息填写页，建议您提前准备以下信息： </div>-->
          <!--                <div class="promptPopups-con-title"></div>-->
          <!--                <div class="promptPopups-con-text">全部乘客的<span class="text-con">姓名、生日以及性别</span></div>-->
          <!--                <div class="footer-btn">-->
          <!--                  <div class="close-btn" @click="closePromptPopups">返回</div>-->
          <!--                  <div class="callPromptBtn" @click="headCallPrompt">进入预订</div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--            </div>-->
          <!--          </div>-->
          <ReserveConfirmPopup v-if="isShowPromptPopups" @closePromptPopups="closePromptPopups"
            @headCallPrompt="headCallPrompt" :hasNrp="hasNrp" :hasRp="hasRp" :hasOutTime="hasOutTime" :contentData="contentData" :cancelPolicy="cancelPolicy" :cancelPolicyNrp="cancelPolicyNrp">
          </ReserveConfirmPopup>

          
        </div>
      </div>
    </div>
    <GuestAlert v-if="isShowVerifyPopup" :text="verifyText" @closePopup="closeVerifyPopup"></GuestAlert>
  </div>
</template>

<script>
import api from "@/api";
import { checkTel, clone, differDays } from "@/utilities/tools";
import ReserveConfirmPopup from "@/components/Booking/ReserveConfirmPopup.vue";
import GuestAlert from "@/components/Alert/GuestAlert.vue";
const RcclCheckBox = () => import("@/components/Common/RcclCheckBox");
const GuestInfoStateroom = () =>
  import("@/components/Booking/GuestInfo/GuestInfoStateroom");
const SelectContact = () =>
  import("@/components/Booking/GuestInfo/SelectContact");
const GuestInfoRight = () =>
  import("@/components/Booking/GuestInfo/GuestInfoRight");
const GuestInfoShorex = () =>
  import("@/components/Booking/GuestInfo/GuestInfoShorex");
  const GuestInfoShorexRow = () =>
  import("@/components/Booking/GuestInfo/GuestInfoShorexRow");


const CruiseDetailPolicy = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailPolicy");
export default {
  name: "GuestInfo",
  components: {
    GuestAlert,
    ReserveConfirmPopup,
    RcclCheckBox,
    GuestInfoStateroom,
    SelectContact,
    GuestInfoRight,
    GuestInfoShorex,
    GuestInfoShorexRow,
    CruiseDetailPolicy,
  },
  beforeMount() {
    // const self = this
    // 隐藏头尾
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: true,
      isHideFooter: false,
    });
    try {
      if (window && window.gio) {
        const hmsr = this.$store.state.page.trackingCode.hmsr || "";
        if (hmsr && hmsr.length > 0) {
          window.gio("track", "BF02_GuestInfoPage", { hmsr: hmsr });
          window.gio("page.set", "CruiseLine", this.shipCode + this.sailDate);
          window.gio("page.set", "ShipCode", this.shipCode);
          window.gio("page.set", "SailDate", this.sailDate);
          window.gio("page.set", "CruiseType", "CruiseOnly");
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  beforeDestroy() {
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: false,
    });
  },
  deactivated() {
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initPage();
    this.getPicCode();
  },
  data() {
    return {
      contentData:'',
      cancelPolicy: '',
      cancelPolicyNrp: '',
      hasNrp: false,
      hasRp: false,
      hasOutTime: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL,
      bookingContact: {
        callingCode: "86",
        chineseFirstName: "",
        chineseLastName: "",
        country: "CN",
        dateOfBirth: "",
        email: "",
        gender: "M",
        isDefaultContact: false,
        passportExpirationDate: "",
        passportNum: "",
        pinyinFirstName: "",
        pinyinLastName: "",
        telephone: "",
        isCommonUseContact: true
      },
      countDown: new Date(),
      countDownText: "",
      countDownTimeout: null,
      userDetail: {},
      contactMode: "contact",
      selectContactIds: [],
      coupons: [],
      isShowSelectContact: 0,  // 0不显示，1中文姓，2中文名
      isShowBankPopup: false,
      isShorexShow: true,
      privacyTab: 0,
      picCodeImage: "",
      picCode: "",
      smsCode: "",
      smsCodeCountDown: 0,
      selectStateroom: {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        stateroomShelter: "",
        deviceFeatureTags: [],
        deviceGroupTags: []
      },
      isInitComplete: false,
      differDays: 0,
      bookingsOriginal: null,
      isShowPromptPopups: false,
      isShowVerifyPopup: false,
      verifyText: "输入邮箱",
      marketingFlagChecked: false
    };
  },
  methods: {
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken == "") {
        this.$router.push({
          name: "Login",
          query: {
            returnUrl: location.href,
          },
        });
        return;
      }
      let bookingKey = this.bookingKey;
      if (!bookingKey || bookingKey == "") {
        const queryKey = this.$router.currentRoute.query.bookingKey;
        if (queryKey && queryKey.length > 0) {
          this.$store.commit("SET_BOOKING_KEY", queryKey);
          bookingKey = queryKey;
        } else {
          return this.goBackShoppingCart();
        }
      }

      const bookingResult = await this.getBookings(bookingKey);
      if (!bookingResult) return;
      this.isInitComplete = true;

      this.$loading.show();
      const userDetail = await api.user.getUserDetail(userToken);
      this.$loading.hide();
      if (userDetail.success) {
        this.userDetail = userDetail.data;
      }

      // this.$loading.show();
      // const couponResult = await api.user.getAvailableCoupons(userToken);
      // this.$loading.hide();
      // if (couponResult.success) {
      //   this.coupons = couponResult.data;
      //   this.couponAutoSelect();
      // }
      this.$store.dispatch("GET_USER_CONTACTS", userToken);


      if (
          this.bookings.length == 0 ||
          this.isSevenDayNrpCruise ||
          this.isFortyEightHoursNrpCruise
      ) {
        return
      }

      if (this.bookings.some((r) => r.isnrp)) {
        await this.getGuestPolicyByCruise(true)
      }
      if (this.bookings.some((r) => !r.isnrp)) {
        await this.getGuestPolicyByCruise(false)
      }

    },
    async getGuestPolicyByCruise(boo) {
      const cruise = await api.user.GetGuestPolicyByCruise({
        CruiseId: this.$store.state.booking.order.cruiseId,
        isNrp: boo,
      });
      // 获取退订策略
      this.isShowPromptPopups = true
      // 1.临近航线政策，2.RP退订政策，3.NRP退订政策
      console.log(cruise, 'cruise')
      if (cruise.data.type == 2) {
        this.hasRp = true
        this.cancelPolicy = cruise.data.body
      } else if (cruise.data.type == 3) {
        this.hasNrp = true
        this.cancelPolicyNrp = cruise.data.body
      } else {
        this.hasOutTime = true
        this.contentData = cruise.data.body
      }
    },
    async getBookings(bookingKey) {
      const { success, data } = await api.booking.guestInfoApi({
        userName: this.$store.state.user.userToken,
        bookingKey,
      });
      if (!success || !data.bookings || data.bookings.length == 0) {
        this.goBackShoppingCart();
        return false;
      }
      this.differDays = differDays(data.sailDate);
      this.bookingsOriginal = data.bookings;
      this.$store.commit("SET_BOOKING_FUNNEL_ORDER", data);
      let initDateTime = new Date(data.initDateTime);
      this.countDown = new Date(
        initDateTime.setMinutes(initDateTime.getMinutes() + 13)
      );
      this.setCountDownText();
      if (data.nationalityApiViews && data.nationalityApiViews.length > 0) {
        this.$store.commit("SET_COUNTRIES", data.nationalityApiViews);
      }
      return true;
    },

    goBack() {
      this.$router.go(-1);
    },
    async checkGuestInfo() {
      this.$loading.show();
      const { success, errMsg } = await api.booking.checkGuest({
        bookingKey: this.bookingKey,
        pppKey: this.pppKey,
      });
      this.$loading.hide();
      if (!success) {
        this.isShowVerifyPopup = true
        this.verifyText = errMsg
      }

      return success;
    },
    //提交订单，提交前检查乘客是否重复
    async checkGuestRepeatSubmitBooking({marketingFlagChecked}) {
      this.marketingFlagChecked = marketingFlagChecked
      let verifyTelephoneCount = 0;
      this.bookings.forEach((row) => {
        row.guests.guestPersons && row.guests.guestPersons.forEach((guest) => {
          if (guest.callingCode === "86") {
            if (guest.telephone && guest.telephone.length > 0 && !checkTel(guest.telephone)) {
              verifyTelephoneCount++;
            }
          }
        });
      });
      if (verifyTelephoneCount > 0) {
        this.isShowVerifyPopup = true
        this.verifyText = '乘客手机号有误，请确认后再提交！'
        return;
      }

      this.$loading.show();
      let passCheckNum = 0;
      for (let i = 0; i < this.bookings.length; i++) {
        const result = await this.checkGuestRepeatHpApi(this.bookings[i]);
        //乘客信息有重复，直接提示，点击确定提交，取消不进行操作
        if (result.success && result.data.isAlert) {
          this.$confirm.show(result.data.alertMsg, {
            confirmBtn: '确定',
            cancelBtn: '取消',
            confirmCallBack: async () => {
              await this.submitBooking();
            }
          })
          break;
        } else {
          passCheckNum++
        }
      }

      //检查通过数和订单数量一致，所有订单通过检查，直接提交
      if (passCheckNum === this.bookings.length) {
        await this.submitBooking();
      }
    },
    //客户重复检查接口调用
    async checkGuestRepeatHpApi(booking) {
      const requestData = {
        bookingKey: this.bookingKey,
        token: booking.sessionToken,
        userName: this.$store.state.user.userToken
      };
      const result = await api.booking.checkGuestRepeatHp(requestData);
      this.$loading.hide();
      return {
        success: result.success,
        errMsg: result.errMsg,
        data: result.data
      };
    },
    async submitBooking() {
      if (!this.checkBookingContact(true)) {
        return;
      }
      try {
        if (window.gio) {
          const hmsr = this.$store.state.page.trackingCode.hmsr || "";
          if (hmsr.length > 0) {
            window.gio("track", "BF03_OrderGenerationPage");
          }
          if (this.bookings.some((r) => r.isnrp)) {
            window.gio("track", "NRP_BF03");
          }
        }
        if (window._hmt) {
          window._hmt.push(["_setPageTag", "4528", 3]);
        }
      } catch (e) {
        console.error(e);
      }
      let viewModel = clone(this.bookingContact);
      // let isCN = this.getCountryArea(this.bookingContact.country);
      viewModel.userName = this.$store.state.user.userToken;
      viewModel.smsCode = this.smsCode;
      // if (isCN) {
      //   viewModel.name = this.bookingContact.chineseLastName.trim() + this.bookingContact.chineseFirstName.trim();
      // } else {
      //   viewModel.name = this.bookingContact.pinyinLastName.trim() + this.bookingContact.pinyinFirstName.trim();
      // }
      viewModel.lastName = viewModel.chineseLastName;
      viewModel.firstName = viewModel.chineseFirstName;
      viewModel.pyLastName = viewModel.pinyinLastName;
      viewModel.pyFirstName = viewModel.pinyinFirstName;
      if(viewModel.name) delete viewModel.name;
      this.$loading.show();
      const { success, errMsg } = await api.booking.addBookingCotact({
        bookingKey: this.bookingKey,
        smsKey: this.smsKey,
        viewModel: viewModel,
      });
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.isShowVerifyPopup = true
        this.verifyText = errMsg
        return;
      }
      // 检查乘客信息
      const checkGuestResult = await this.checkGuestInfo();
      if (!checkGuestResult) return;

      let results = [];
      for (let i = 0; i < this.bookings.length; i++) {
        const reuslt = await this.submitBookingApi(this.bookings[i]);
        results.push(reuslt);
      }
      this.submitBookingResultHandler(results);
    },
    async submitBookingApi(booking) {
      this.$loading.show();
      const requestData = {
        bookingKey: this.bookingKey,
        shorexId: this.shorex.id,
        token: booking.sessionToken,
        couponCode: booking.couponCode,
        publicCouponCode: booking.publicCouponCode,
        source: "online",
        auth: true,
        pppKey: this.$store.state.user.pppKey,
        marketingFlag: this.marketingFlagChecked
      };
      const result = await api.booking.submitBooking(requestData);
      this.$loading.hide();
      return {
        success: result.success,
        booking: booking,
        showAlert: true,
        errMsg: result.errMsg,
        data: result.data,
      };
    },
    // 预订提交后的处理
    // 如果全部失败，alert提示
    // 如果部分失败，confirm提示，并刷新页面
    // 如果全部成功，进入支付页面
    submitBookingResultHandler(results) {
      if (results.length == 0) {
        return;
      }
      this.$store.dispatch("GET_SHOPPING_CART_COUNT");
      const failureResults = results.filter((r) => !r.success);
      const successResults = results.filter((r) => r.success);
      if (failureResults.length == 0) {
        // 全部成功，进入支付页面
        location.href = `/Rccl.Booking/Booking/Pay?orderId=${successResults[0].data}&shipCode=${this.shipCode}&sailDate=${this.sailDate}`;
      } else {
        const self = this;
        let stateroomInfo = [];
        failureResults.forEach((result) => {
          if (result.booking) {
            stateroomInfo.push(result.errMsg);
          }
        });
        const stateroomText = stateroomInfo.join("，");
        if (failureResults.length < results.length) {
          // 如果部分失败，confirm提示，并刷新页面
          const text = `您选择的&nbsp;<span class="failureRoomTxt">${stateroomText}</span>，您可以继续为已创建的订单付款。`;
          self.$confirm.show(text, {
            confirmCallBack: () => {
              self.$router.push({
                name: "Pay",
                query: {
                  shipCode: self.shipCode,
                  sailDate: self.sailDate,
                  orderId: successResults[0].data,
                },
              });
            },
            cancelCallBack: () => {
              location.reload();
            },
            confirmBtn: "去支付",
          });
        } else {
          // 如果全部失败，alert提示
          const text = `您选择的&nbsp;<span class="failureRoomTxt">${stateroomText}</span>，请重新刷新该页面。`;
          self.$alert.show(text);
        }
      }
    },
    getCountryArea(country) {
      return country === "CN" ||
        country === "HK" ||
        country === "MAC" ||
        country === "TWN";
    },
    checkBookingContact(isShowAlert) {
      let isCN = this.getCountryArea(this.bookingContact.country);
      if (isCN) {
        if (!this.bookingContact.chineseLastName || this.bookingContact.chineseLastName.trim() == "") {
          if (isShowAlert) {
            this.isShowVerifyPopup = true
            this.verifyText = "请输入中文姓"
          }
          return false;
        }
        if (!this.bookingContact.chineseFirstName || this.bookingContact.chineseFirstName.trim() == "") {
          if (isShowAlert) {
            this.isShowVerifyPopup = true
            this.verifyText = "请输入中文名"
          }
          return false;
        }
      }
      if (!this.bookingContact.pinyinLastName || this.bookingContact.pinyinLastName.trim() == "") {
        if (isShowAlert) {
          this.isShowVerifyPopup = true
          this.verifyText = "请输入拼音姓"
        }
        return false;
      }
      if (!this.bookingContact.pinyinFirstName || this.bookingContact.pinyinFirstName.trim() == "") {
        if (isShowAlert) {
          this.isShowVerifyPopup = true
          this.verifyText = "请输入拼音名"
        }
        return false;
      }
      if (
        !this.bookingContact.telephone ||
        this.bookingContact.telephone.trim() == ""
      ) {
        if (isShowAlert) {
          this.isShowVerifyPopup = true
          this.verifyText = "请输入联系人手机号"
        }
        return false;
      }
      if (
        !this.bookingContact.email ||
        this.bookingContact.email.trim() == ""
      ) {
        if (isShowAlert) {
          this.isShowVerifyPopup = true
          this.verifyText = "请输入联系人邮箱"
        }
        return false;
      }
      return true;
    },
    // 优惠券自动选择
    async couponAutoSelect() {
      if (!this.coupons || this.coupons.length == 0) {
        return;
      }
      if (this.pppKey && this.pppKey.length > 0) {
        return;
      }
      for (let i = 0; i < this.bookings.length; i++) {
        let booking = this.bookings[i];
        if (booking.couponCode && booking.couponCode.length > 0) {
          // 如果之前已经选择过优惠券了，跳过
          continue;
        }
        for (let j = 0; j < this.coupons.length; j++) {
          const coupon = this.coupons[j];
          // 跳过会员专属优惠券和OPBK优惠
          if (coupon.isMemberSelfUse || coupon.isSelfUse) continue;
          if (await this.addCouponCode(booking, coupon.token, coupon, false)) {
            break;
          }
        }
      }
    },
    // 检查优惠券是否可以选择
    checkCouponCanUse(booking, coupon, isShowAlert) {
      // 先检查优惠券是否被其他订单使用了
      if (
        this.bookings.some(
          (r) =>
            r.sessionToken != booking.sessionToken &&
            r.couponCode == coupon.token
        )
      ) {
        if (isShowAlert) {
          this.isShowVerifyPopup = true
          this.verifyText = "该优惠券已被选中，请更换优惠券"
        }
        return false;
      }
      // 检查是否满足舱房，人数和航线要求
      const cruiseCode = this.getCruiseCode(booking);
      if (cruiseCode == "") {
        return false;
      }
      if (!coupon.cruiseCodes || coupon.cruiseCodes.indexOf(cruiseCode) < 0) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }
      const stateroomCode = booking.shipCode + booking.berthedCategoryCode;
      if (
        !coupon.stateroomCodes ||
        coupon.stateroomCodes.indexOf(stateroomCode) < 0
      ) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }
      if (
        !coupon.guestNumber ||
        coupon.guestNumber.indexOf(booking.guestNumber + "") < 0
      ) {
        if (isShowAlert) {
          this.$alert.show("该优惠券不适用此航次/舱房，请更换优惠券");
        }
        return false;
      }

      // 检查会员优惠券，当前用户必须是会员，拼音姓名和护照必须填写，并且必须再当前订单乘客中
      // 改由后台判断
      // if (coupon.isMemberSelfUse) {
      //     if (!this.userDetail || !this.userDetail.firstNamePinYin || this.userDetail.firstNamePinYin.length == 0
      //     || !this.userDetail.lastNamePinYin || this.userDetail.lastNamePinYin.length == 0
      //     || !this.userDetail.passportNo || this.userDetail.passportNo.length == 0) {
      //     || !this.userDetail.passportNo || this.userDetail.passportNo.length == 0) {
      //         if (isShowAlert) {
      //             this.$alert.show('需先填写会员本人乘客信息并准确录入护照号，方可使用该券。')
      //         }
      //         return false
      //     }
      //     if (!booking.guests || !booking.guests.guestPersons ||
      //     !booking.guests.guestPersons.some(r=>r.pyLastName == this.userDetail.lastNamePinYin && r.pyFirstName == this.userDetail.firstNamePinYin
      //     && r.passport == this.userDetail.passportNo)) {
      //         if (isShowAlert) {
      //             this.$alert.show('需先填写会员本人乘客信息并准确录入护照号，方可使用该券。')
      //         }
      //         return false
      //     }
      // }

      return true;
    },
    // 添加优惠券接口
    async addCouponCode(booking, couponCode, coupon, isShowAlert) {
      if (
        couponCode &&
        couponCode.length > 0 &&
        !this.checkCouponCanUse(booking, coupon, isShowAlert)
      ) {
        return false;
      }
      const requestData = {
        token: booking.sessionToken,
        couponCode: couponCode,
        publicCouponCode: booking.publicCouponCode,
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        stateroomCategoryCode: booking.berthedCategoryCode,
        guestNumber: booking.guestNumber,
        bookingKey: this.bookingKey,
        pppKey: this.pppKey
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.updateCouponCode(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        booking.couponCode = "";
        return false;
      }
      booking.couponCode = couponCode;
      if (data && data.model && data.model.bookings) {
        let order = this.order;
        this.order.bookings.forEach((booking) => {
          let apiBooking = data.model.bookings.find(
            (r) => r.sessionToken == booking.sessionToken
          );
          if (apiBooking && apiBooking.guestPrices && apiBooking.prices) {
            booking.guestPrices = apiBooking.guestPrices;
            booking.prices = apiBooking.prices;
            booking.netAmount = apiBooking.netAmount;
            booking.bookingIntegrals = apiBooking.bookingIntegrals;
          }
        });
        this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
      }
      return true;
    },
    // 输入活动码
    async addPublicCouponCode(e, sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      const booking = bookings[0];
      let value = e.target.value;
      const requestData = {
        token: booking.sessionToken,
        couponCode: booking.couponCode,
        publicCouponCode: value,
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        stateroomCategoryCode: booking.berthedCategoryCode,
        guestNumber: booking.guestNumber,
        bookingKey: this.bookingKey,
        pppKey: this.pppKey
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.updateCouponCode(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        if (errMsg == 2000) {
          this.goBackShoppingCart();
          return false;
        }
        this.$alert.show(errMsg);
        return false;
      }
      booking.publicCouponCode = value;
      if (data && data.model && data.model.bookings) {
        let order = this.order;
        this.order.bookings.forEach((booking) => {
          let apiBooking = data.model.bookings.find(
            (r) => r.sessionToken == booking.sessionToken
          );
          if (apiBooking && apiBooking.guestPrices && apiBooking.prices) {
            booking.guestPrices = apiBooking.guestPrices;
            booking.prices = apiBooking.prices;
            booking.netAmount = apiBooking.netAmount;
          }
        });
        this.$store.commit("SET_BOOKING_FUNNEL_ORDER", order);
      }
      return true;
    },
    // 优惠券选择后的处理
    async onCouponCodeSelected(e, sessionToken) {
      const bookings = this.bookings.filter(
        (r) => r.sessionToken == sessionToken
      );
      if (bookings.length == 0) return;
      let value = e.target.value;
      let result = true;
      if (value == "") {
        result = await this.addCouponCode(bookings[0], value, true);
      } else {
        const coupon = this.coupons.filter((r) => r.token == value);
        if (coupon.length == 0) {
          return;
        }
        result = await this.addCouponCode(bookings[0], value, coupon[0], true);
      }
      // 如果优惠券不满足条件，设置回之前选择的券
      if (!result) {
        e.target.value = bookings[0].couponCode;
      }
    },
    // 获取SC20210511格式code
    getCruiseCode(booking) {
      const sailDate = booking.sailDate;
      if (sailDate && booking.sailDate.length >= 10) {
        let lists = sailDate.split("-");
        return booking.shipCode + lists[0] + lists[1] + lists[2];
      }
      return "";
    },

    // 确认订单联系人
    async onBookingContactConfirm(contact) {
      let name = contact.chineseLastName + contact.chineseFirstName;
      if (!name || name.trim().length == 0) {
        name = `${contact.pinyinLastName} ${contact.pinyinFirstName}`;
      }
      let bookingContact = clone(contact);
      bookingContact.name = name;
      this.bookingContact = bookingContact;
      if (!this.bookingKey || this.bookingKey.length == 0) {
        return;
      }
      let viewModel = clone(this.bookingContact);
      viewModel.userName = this.$store.state.user.userToken;
      viewModel.smsCode = this.smsCode;
      this.$loading.show();
      await api.booking.addBookingCotact({
        bookingKey: this.bookingKey,
        smsKey: this.smsKey,
        viewModel: viewModel,
      });
      this.$loading.hide();
    },
    clearBookingContact() {
      this.bookingContact = {
        // name: "",
        callingCode: "86",
        chineseFirstName: "",
        chineseLastName: "",
        country: "CN",
        dateOfBirth: "",
        email: "",
        gender: "M",
        isDefaultContact: false,
        passportExpirationDate: "",
        passportNum: "",
        pinyinFirstName: "",
        pinyinLastName: "",
        lastName: "",
        firstName: "",
        pyLastName: "",
        pyFirstName: ""
      };
    },
    // 获取舱房对象
    getStateroom(booking) {
      if (!booking.stateroomPartRecord) {
        return {};
      }
      return booking.stateroomPartRecord;
    },
    // 获取图形验证码
    async getPicCode() {
      const { success, data, errMsg } = await api.user.picCode(this.smsKey);
      if (!success) console.error(errMsg);
      if (data) {
        this.picCodeImage = "data:image/png;base64," + data.imageBase64;
        this.$store.dispatch("SET_SESSION_KEY", data.sessionKey);
      }
    },
    // 获取短信验证码
    async sendSmsCode() {
      if (this.smsCodeCountDown > 0) {
        return;
      }
      this.$loading.show();
      let callingCode = this.bookingContact.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }
      const { success, errMsg } = await api.user.smsCode({
        phone: this.bookingContact.telephone,
        picCode: this.picCode,
        callingCode: callingCode,
        sessionKey: this.smsKey,
      });
      this.$loading.hide();
      this.getPicCode();
      if (!success) {
        this.isShowVerifyPopup = true
        this.verifyText = errMsg
        return;
      } else {
        this.isShowVerifyPopup = true
        this.verifyText = "短信发送成功！若您没有收到短信验证，请一分钟后重新发送。"
      }
      this.smsCodeCountDown = 60;
      const self = this;
      let countDown = setInterval(() => {
        if (self.smsCodeCountDown == 0) {
          clearInterval(countDown);
        } else {
          self.smsCodeCountDown--;
        }
      }, 1000);
    },
    onSelectContactClose() {
      this.isShowSelectContact = 0;
    },
    onSelectContactShow(i) {
      let contacts = this.contacts && this.contacts.filter(item => item.email && item.telephone)
      if (contacts.length === 0) return;
      this.isShowSelectContact = i;
    },
    onSelectContactConfirm(guests) {
      if (guests.length == 0) return;
      const guest = guests[0];
      // this.bookingContact.name = guest.name;
      this.bookingContact.firstName = guest.firstName;
      this.bookingContact.lastName = guest.lastName;
      this.bookingContact.pyFirstName = guest.pyFirstName;
      this.bookingContact.pyLastName = guest.pyLastName;
      this.bookingContact.chineseFirstName = guest.firstName;
      this.bookingContact.chineseLastName = guest.lastName;
      this.bookingContact.pinyinFirstName = guest.pyFirstName;
      this.bookingContact.pinyinLastName = guest.pyLastName;
      this.bookingContact.telephone = guest.telephone;
      this.bookingContact.callingCode = guest.callingCode || "86";
      this.bookingContact.email = guest.email;
    },
    callingCodeChanged(value) {
      let code = value + "";
      if (code && code.length > 0) {
        this.bookingContact.callingCode = code.replace("+", "");
      }
    },
    showBankPopup() {
      this.isShowBankPopup = true;
    },
    closeBankPopup() {
      this.isShowBankPopup = false;
    },
    goBackShoppingCart() {
      const query = this.$router.currentRoute.query;
      if (query.shipCode && query.sailDate) {
        this.$router.push({
          name: "CruiseDetail",
          query: {
            shipCode: query.shipCode,
            sailDate: query.sailDate,
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    setCountDownText() {
      const self = this;
      const endDate = new Date(this.countDown).getTime();
      const curDate = new Date().getTime();
      const totalSeconds = parseInt((endDate - curDate) / 1000);
      if (totalSeconds >= 0) {
        const minute = this.fixedTime(Math.floor((totalSeconds / 60) % 60));
        const second = this.fixedTime(Math.floor(totalSeconds % 60));
        self.countDownText = `${minute}:${second}`;
        this.countDownTimeout = setTimeout(() => {
          self.setCountDownText();
        }, 1000);
      } else {
        if (this.$router.currentRoute.name != "GuestInfo") return;
        this.$confirm.show("房间预订超时,是否续订房间", {
          confirmCallBack: () => {
            if (self.$router.currentRoute.name != "GuestInfo") return;
            self.refreshLockStateroom();
          },
          cancelCallBack: () => {
            if (self.$router.currentRoute.name != "GuestInfo") return;
            self.goBackShoppingCart();
          },
        });
      }
    },
    fixedTime(time) {
      if (time < 10) {
        return "0" + time;
      }
      return time + "";
    },
    async refreshLockStateroom() {
      this.$loading.show();
      const result = await api.booking.refreshLockStateroom({
        bookingKey: this.bookingKey,
      });
      this.$loading.hide();
      if (!result.success) {
        this.goBackShoppingCart();
        return;
      }
      await this.getBookings(this.bookingKey);
      this.$store.commit("SET_PAGE_REFRESH", new Date().getTime().toString());
    },
    goToLocalReward() {
      this.$router.push(
        `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
          location.href
        )}`
      );
    },
    goToCompleteInfo() {
      this.$router.push(
        `/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
          location.href
        )}`
      );
    },
    closePromptPopups() {
      this.$router.go(-1);
    },
    async headCallPrompt() {
      this.isShowPromptPopups = false
      this.$loading.show();
      const couponResult = await api.user.getAvailableCoupons(this.$store.state.user.userToken);
      this.$loading.hide();
      if (couponResult.success) {
        this.coupons = couponResult.data;
        await this.couponAutoSelect();
      }
    },
    async onNameChanged(key) {
      let value = ''
      if (key == "firstName") {
        value = this.bookingContact.chineseFirstName
      } else if (key == 'lastName') {
        value = this.bookingContact.chineseLastName
      }
      if (value.length > 0) {
        await this.getPinyin(key, value)
      }
    },
    async getPinyin(key, value) {
      if (!value || value.length == 0) return
      const { data } = await api.page.getPinyin(value)
      if (data && data.length > 0) {
        if (key == 'firstName') {
          this.bookingContact.pinyinFirstName = data
        } else if (key == 'lastName') {
          this.bookingContact.pinyinLastName = data
        }
      }
    },
    checkIsCommonChanged(e) {
      this.bookingContact.isCommonUseContact = e
    },
    // 关闭验证弹窗
    closeVerifyPopup() {
      this.isShowVerifyPopup = false
      this.verifyText = ""
    }
  },
  computed: {
    bookingKey() {
      return this.$store.state.booking.bookingKey;
    },
    pppKey() {
      return this.$store.state.user.pppKey;
    },
    order() {
      console.log("orderorder", this.$store.state.booking.order);
      return this.$store.state.booking.order;
    },
    bookings() {
      if (!this.order.bookings || this.order.bookings.length == 0) {
        return [];
      }
      return this.order.bookings;
    },

    shipCode() {
      if (!this.bookings || this.bookings.length == 0) {
        return "";
      }
      return this.bookings[0].shipCode;
    },
    sailDate() {
      if (!this.bookings || this.bookings.length == 0) {
        return "";
      }
      return this.bookings[0].sailDate;
    },
    contact() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return {};
      }
      return this.order.bookings[0].contact;
    },
    needShowSmsCode() {
      const user = this.$store.state.user.userInfo;
      if (!user || !user.mobile || user.mobile == "") return true;
      return (
        !this.bookingContact ||
        !this.bookingContact.telephone ||
        this.bookingContact.telephone != user.mobile
      );
    },
    normalBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }
      return this.order.bookings.filter(
        (r) => !r.connectId || r.connectId == ""
      );
    },
    connectBookings() {
      if (
        !this.order ||
        !this.order.bookings ||
        this.order.bookings.length == 0
      ) {
        return [];
      }
      return this.order.bookings.filter(
        (r) => r.connectId && r.connectId.length > 0
      );
    },

    isFortyEightHoursNrpCruise() {
      return this.order.isFortyEightHoursNrpCruise;
    },
    isShowSmsCode() {
      return (
        this.bookingContact &&
        this.bookingContact.telephone &&
        this.bookingContact.telephone.length > 0 &&
        this.userDetail &&
        this.bookingContact.telephone != this.userDetail.mobile
      );
    },
    smsCallingCodes() {
      return this.$store.getters.smsCallingCodes;
    },
    smsKey() {
      return this.$store.state.page.sessionKey;
    },
    smsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
    selectContactPosition() {
      return {};
    },
    countries() {
      if (
        !this.$store.state.page.countries ||
        this.$store.state.page.countries.length == 0
      ) {
        return [];
      }
      return this.$store.state.page.countries.filter(
        (r) =>
          r.countryName &&
          r.countryName.length > 0 &&
          r.countryCode &&
          r.countryCode.length > 0
      );
    },
    callingCodes() {
      return this.countries.filter(
        (r) => r.callingCode && r.callingCode.length > 0 && r.isAllowSendSms
      );
    },
    selectedCallingCode() {
      let selectCallingCode = this.bookingContact.callingCode + "";
      if (
        !this.bookingContact.callingCode ||
        this.bookingContact.callingCode.length == 0
      ) {
        selectCallingCode = "86";
      }
      if (this.bookingContact.callingCode.indexOf("+") < 0) {
        selectCallingCode = "+" + selectCallingCode;
      }
      return (
        this.callingCodes.find((r) => r.callingCode == selectCallingCode) || {}
      );
    },
    shorex() {
      if (!this.order || !this.order.shorex) {
        return {};
      }
      return this.order.shorex;
    },
    isLocalReward() {
      return (
        this.userDetail &&
        this.userDetail.memberLevelStr &&
        this.userDetail.memberLevelStr.length > 0
      );
    },
    isFinishSelfInfo() {
      let userInfo = this.$store.state.user.userInfo;
      let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
      return isLocalReward && userInfo.infoIntegrity === 100;
    },
    specialBookingInfo() {
      const order = this.$store.state.booking.order;
      if (
        !order ||
        !order.specialBookingInfoView ||
        !order.specialBookingInfoView.specialBookingViewModels ||
        order.specialBookingInfoView.specialBookingViewModels.length <= 0
      ) {
        return {};
      }
      return order.specialBookingInfoView.specialBookingViewModels[0];
    },
    contacts() {
      return this.$store.state.user.contacts || [];
    },
  },
  watch: {
    contacts(val) {
      let contactList = (val && val.filter(item => item.isDefaultContact)) || [];
      if(contactList.length === 0) {
        contactList = val && val.filter(item => item.email && item.telephone)
      }
      let obj = (contactList && contactList.length) ? contactList[0] : {};
      if(obj) {
        this.bookingContact = {
          // name: obj.name,
          telephone: obj.telephone,
          email: obj.email,
          lastName: obj.chineseLastName,
          firstName: obj.chineseFirstName,
          pyLastName: obj.pinyinLastName,
          pyFirstName: obj.pinyinFirstName,
          id: obj.id,
          callingCode: obj.callingCode,
          isCommonUseContact: true,
          chineseFirstName: obj.chineseFirstName,
          chineseLastName: obj.chineseLastName,
          pinyinFirstName: obj.pinyinFirstName,
          pinyinLastName: obj.pinyinLastName
        };
      }
    }
    // contact(newOne) {
    //   if (
    //     !this.bookingContact ||
    //     !this.bookingContact.name ||
    //     this.bookingContact.name == "" ||
    //     !this.bookingContact.telephone ||
    //     this.bookingContact.telephone == "" ||
    //     !this.bookingContact.email ||
    //     this.bookingContact.email == ""
    //   ) {
    //     this.bookingContact = {
    //       name: newOne.name,
    //       telephone: newOne.telephone,
    //       email: newOne.email,
    //       lastName: newOne.lastName,
    //       firstName: newOne.firstName,
    //       id: newOne.id,
    //       callingCode: newOne.callingCode,
    //       isCommonUseContact: true,
    //       chineseFirstName: newOne.firstName,
    //       chineseLastName: newOne.lastName,
    //       pinyinFirstName: newOne.pyFirstName,
    //       pinyinLastName: newOne.pyLastName,
    //     };
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.font--blue {
  cursor: pointer;
  color: #0a55ad;
}

.head_top {
  position: relative;
  height: 74px;
  top: 0;
  z-index: 11;
  width: 100%;

  .header-main {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    .logo {
      margin-top: 9px;
      margin-left: 0;
    }
  }
}

.content-warp {
  font-family: "Microsoft Yahei", latolight, Arial, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  width: 100%;
  min-height: 100%;
  background: #f5f5f5;
  color: #282b2c;

  .content-tips {
    position: relative;
    color: #282b2c;
    text-align: center;
    margin-bottom: 30px;
    height: 124px;
    z-index: 10;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background: linear-gradient(to right, #855902 50%, #000000 50%);
    }

    &>.bg {
      position: relative;
      text-align: center;
      height: 124px;
      z-index: 2;
      background: url("https://resource.rcclchina.com.cn/orderInfo/order-submit-bg.jpg") center top no-repeat;
    }

    &>.inner {
      text-align: left;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -600px;
      width: 1200px;
      height: 124px;
      font-size: 24px;
      color: #FFFFFF;
      z-index: 99;

      & .logo {
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: 57px;
      }

      & em {
        font-size: 30px;
        line-height: 36px;
        font-style: normal;
        font-weight: bold;
        padding: 0 5px;
      }

      & span {
        font-size: 36px;
        padding: 0 5px;
        border-bottom: 1px solid rgba(255, 255, 255, .6);
      }

      & div {
        margin-left: 77px;
      }

      & .row-1 {
        padding-top: 18px;
      }

      & .row-2 {
        margin-top: -3px;
        height: 47px;
      }
    }

    &>.inner-center {
      text-align: center;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -550px;
      width: 1000px;
      height: 124px;
      font-size: 24px;
      color: #FFFFFF;
      z-index: 99;

      & .logo {
        display: block;
        margin: 8px auto 0;
        height: 52px;
      }

      & em {
        font-size: 30px;
        line-height: 36px;
        font-style: normal;
        font-weight: bold;
        padding: 0 5px;
      }

      & span {
        font-size: 36px;
        padding: 0 5px;
        border-bottom: 1px solid rgba(255, 255, 255, .6);
      }

      & .row {
        height: 47px;
        margin-top: -5px;
      }
    }
  }

  .content-main {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    background: #f5f5f5;
    padding-bottom: 40px;
    display: flex;

    .comment-css {
      font-size: 12px;
      color: #a6aeb1;
      position: relative;
      top: 2px;
      left: 2px;
    }

    .content-main-left {
      display: inline-block;
      width: 884px;
      padding-right: 20px;

      .form-warp {
        background: #fff;
        padding-bottom: 20px;

        .contact-warp {
          padding: 10px;

          .contact-title {
            font-size: 22px;
            letter-spacing: 1px;
            color: #282b2c;
            font-weight: 500;
          }

          .contact-save-btn {
            margin-left: 20px;
            margin-top: 20px;
          }

          .contact-form {
            margin-left: 20px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            column-gap: 50px;

            >div {
              margin-top: 20px;
            }
          }
        }
      }

      .tips-warp {
        margin: 10px 0;

        div {
          display: flex;
          align-items: center;
          gap: 3px;
          margin-bottom: 10px;

          img {
            width: 16px;
            height: 16px;
          }
        }

        div:last-child {
          margin-bottom: 15px;
        }
      }

      .product-info {
        padding: 22px 22px 30px;
        color: #747d80;
        //width: 841px;
        vertical-align: 2px;
        margin-bottom: 10px;
        background: #fff;

        .product-title {
          font-size: 22px;
          letter-spacing: 1px;
          color: #282b2c;
        }

        .css_Reservation {
          height: 600px;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>

<style lang="less">
.content-main {
  .content-main-left {
    .input-warp {
      position: relative;
      width: 333px;
      display: flex;

      .picCodeImg {
        position: absolute;
        top: 50%;
        right: -65px;
        transform: translate(0, -70%);
      }
    }

    label {
      color: #747d80;
      letter-spacing: 1px;
      font-weight: 400;
      margin-bottom: 0;
    }

    .input-lable {
      //width: 60px;
      margin-right: 10px;
      white-space: nowrap;

      &.sms {
        //width: 85px;
      }
    }

    input {
      border: none;
      border-bottom: solid 1px #d3dadd;
      vertical-align: -2px;
      font-style: normal;
      padding-left: 10px;
      padding-bottom: 5px;
    }

    input::-webkit-input-placeholder {
      font-family: MicrosoftYaHei;
      /* font-style: normal; */
      font-size: 14px;
      letter-spacing: 1px;
      color: #919b9f;
      padding-bottom: 10px;
    }

    select {
      border: 0;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      background: url(https://resource.rcclchina.com.cn/tui2/list/icon-down.png) 230px center no-repeat;
      background-size: 12px;
    }

    input[type="text"] {
      width: 100%;
    }

    .claer-lable {
      color: #006ab9;
      cursor: pointer;
      margin-left: 5px;
      vertical-align: middle;
    }

    .callingCode {
      display: inline-block;

      .btn {
        padding: 1px 0 1px 10px;
        border: none;
        border-bottom: solid 1px #d3dadd;
        background-color: white;
        vertical-align: -2px;
        font-style: normal;
        margin-right: 5px;
        border-radius: 0;

        .caret {
          margin-left: 5px;
        }
      }

      ul {
        max-height: 300px;
        overflow-y: scroll;

        a {
          cursor: pointer;
        }
      }
    }
  }
}

.promptPopups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.8);
  /* padding: 0 74rpx; */
}
</style>
